import React from "react";

import organizationTypes from "astrid-firestore/src/api/organizations/constants/organizationTypes";

import ListReaders from "../components/reader/ListReaders";
import { useProfile } from "../features/authentication/state/profile";
import useHasRight from "../features/authorization/hooks/useHasRight";
import { useOrganizationId } from "../features/organizations/state/organizationId";
import { useOrganizationType } from "../features/organizations/state/organizationType";
import Unauthorized from "../features/ui/components/Unauthorized/Unauthorized";

const Reader = (props) => {
	const hasRight = useHasRight();
	const profile = useProfile();
	const organizationId = useOrganizationId();
	const organizationType = useOrganizationType();

	if (!hasRight("readers.view")) {
		return <Unauthorized />;
	}

	const producerId = organizationType === organizationTypes.PRODUCER ? organizationId : undefined;

	const readerScope = producerId
		? ["allProducers", producerId]
		: organizationType === organizationTypes.PUBLISHER
		? ["allPublishers"]
		: ["any"];

	return <ListReaders {...props} profile={profile} producerId={producerId} readerScope={readerScope} />;
};

export default Reader;
